
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CreditCard } from "lucide-react";

interface FreePlanViewProps {
  onUpgrade: () => void;
}

export function FreePlanView({ onUpgrade }: FreePlanViewProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">Subscription</CardTitle>
        <CardDescription>Manage your subscription</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <p>You are currently on the Free plan.</p>
        <Button onClick={onUpgrade}>
          <CreditCard className="mr-2 h-4 w-4" /> Upgrade to Pro
        </Button>
      </CardContent>
    </Card>
  );
}
